import React from "react";
import "../styles/ChecklistCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function ChecklistCard({
  CheckListData,
  CheckListData2,
  CheckListData3,
  Header,
  Header2,
  Title1,
  Title2,
  Title3,
  province,
}) {
  return (
    <div className="checklist-card checklist-card-modern">
      <div className="flex flex-wrap checklist-card-header">
        <div>{Header}</div> &nbsp;
        <div>{Header2}</div>
      </div>
      <div className="clause-card-content">
      {Title1 !== undefined ? (
        <>
          <h2 className="pl-3 pb-5">{Title1}</h2>
          <ul>
            {CheckListData.map((item, index) => (
              <div key={index} className="pl-5 flex items-top">
                <FontAwesomeIcon
                  icon={faCheck}
                  size="lg"
                  color="#00ad43"
                  className=" pr-1 pb-1"
                />
                <li>{item}</li>
              </div>
            ))}
          </ul>
        </>
      ) : (
        ""
      )}
      <br />
      {Title2 !== undefined ? (
        <>
          <h2 className="pl-3 pb-5">{Title2}</h2>
          <ul>
            {CheckListData2.map((item, index) => (
              <div key={index} className="pl-5 flex items-top">
                <FontAwesomeIcon
                  icon={faCheck}
                  size="lg"
                  color="#00ad43"
                  className="pr-1 pb-1"
                />
                <li>{item}</li>
              </div>
            ))}
          </ul>
        </>
      ) : (
        ""
      )}
      <br />
      {Title3 !== undefined ? (
        <>
          <h2 className="pl-3 pb-5">{Title3}</h2>
          <ul>
            {CheckListData3.map((item, index) => (
              <div key={index} className="pl-5 flex items-top">
                <FontAwesomeIcon
                  icon={faCheck}
                  size="lg"
                  color="#00ad43"
                  className="pr-1 pb-1"
                />
                <li>{item}</li>
              </div>
            ))}
          </ul>
          <div className="pb-3"></div>
        </>
      ) : (
        ""
      )}
      <div className="pl-5 pb-2">
        For direction on how to fill out these, or any other forms, visit the{" "}
        <a
          href={`/${province}/common-forms`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Common Forms
        </a>{" "}
        section.
      </div>
      </div>
    </div>
  );
}
